
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinbuldhana() {



const cardData = {
  keyword: 'Cab Service in Buldhana MIDC',
  heading: 'eTravo: Cab Service in Buldhana MIDC',
  headingDescription: `eTravo proudly offers professional cab services in Buldhana MIDC, catering to the daily transportation requirements of industries, corporate offices, and visiting professionals in this emerging industrial zone. Whether you need reliable employee commuting, executive transfers, or guest transportation, our GPS-enabled, air-conditioned fleet ensures every ride is smooth, safe, and on time. Operated by skilled drivers trained in corporate etiquette, eTravo guarantees punctuality and professionalism. We provide flexible rental packages, route optimization, and round-the-clock customer support to help businesses in Buldhana MIDC maintain efficient and stress-free mobility. Choose eTravo for trusted and seamless travel solutions that align with your industrial operations.`,

  top: 'Top Places to visit in Buldhana with eTravo',
    "topPlaces": [
    {
      "title": "Buldhana MIDC Industrial Area",
      "description": "The Buldhana MIDC Industrial Area is a significant hub hosting a variety of industries, including agro-processing units, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Buldhana City Center",
      "description": "The commercial and administrative heart of Buldhana, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Malkapur Railway Station",
      "description": "A crucial railway hub connecting Buldhana with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Shegaon Railway Station",
      "description": "Serving as another vital rail link in the district, Shegaon Railway Station facilitates regional connectivity. eTravo provides dependable cab services for passengers and employees commuting to and from the station."
    },
    {
      "title": "Khamgaon Industrial Zone",
      "description": "An emerging industrial area focusing on agro-based industries and small-scale manufacturing units. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Pankaj Laddhad Institute of Technology and Management Studies",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Buldhana",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Podar International School, Buldhana",
      "description": "An esteemed educational institution offering quality education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Laddhad Hospital, Buldhana",
      "description": "A multi-specialty hospital serving the healthcare needs of Buldhana residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    },
    {
      "title": "Anand Sagar Complex, Shegaon",
      "description": "A popular tourist and spiritual destination in Buldhana district, attracting visitors from various regions. eTravo facilitates transportation for tourists and staff, enhancing the travel experience with convenient and safe travel options."
    }
  ],

services: [
  {
    name: 'Buldhana MIDC Corporate Cab Rentals',
    description: `Customized corporate cab rental solutions designed to meet the dynamic transportation needs of businesses in Buldhana MIDC. Our fleet includes a range of vehicles maintained to high standards, offering flexible rental terms for daily commutes, corporate events, or long-term contracts with dedicated support.`
  },
  {
    name: 'Employee Transport Cab Buldhana MIDC',
    description: `Dependable employee transport services synchronized with factory and office shifts in Buldhana MIDC. Equipped with GPS tracking and supervised by a responsive support team, our vehicles ensure timely, safe, and comfortable daily journeys to and from the workplace.`
  },
  {
    name: 'Business Cab Services Buldhana MIDC',
    description: `Efficient and adaptive cab services catering to business executives and staff for meetings, client visits, and industrial site inspections. Our professional drivers possess thorough local knowledge to navigate the area swiftly, ensuring punctual and comfortable business travel.`
  },
  {
    name: 'Corporate Staff Cabs Buldhana MIDC',
    description: `Group transport services with optimized multi-route planning and GPS monitoring, designed for corporate teams commuting collectively. This solution promotes cost savings, reduces traffic congestion, and enhances employee safety through coordinated pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Buldhana MIDC',
    description: `Our commitment to quality includes maintaining clean, well-serviced vehicles and professional drivers trained to meet corporate standards. Punctuality, courteous service, and proactive communication are the pillars of our corporate cab service in Buldhana MIDC.`
  },
  {
    name: 'AC Corporate Cabs Buldhana MIDC',
    description: `Comfort-focused air-conditioned cab services providing a cool and relaxed travel environment, suitable for year-round commuting. Perfect for daily employee transport and executive rides, our AC fleet ensures a pleasant journey even during peak summer in Buldhana.`
  },
  {
    name: 'Staff Pickup and Drop Cab Buldhana MIDC',
    description: `Comprehensive staff transport covering multiple shifts including night duties, with flexible scheduling and reliable timings. Available 24/7, our skilled drivers ensure your workforce’s safe and punctual travel, supporting continuous operations at all hours.`
  },
  {
    name: 'Affordable Business Cab Rentals Buldhana MIDC',
    description: `Cost-efficient cab rental plans designed to suit small to large businesses with transparent pricing and scalable vehicle options. Our service helps companies manage transportation budgets effectively without compromising service quality or reliability.`
  },
  {
    name: 'Executive Cab Services Buldhana MIDC',
    description: `Premium executive transportation featuring luxury vehicles and professional chauffeurs. Ideal for airport transfers, high-profile client visits, and important corporate meetings, offering discreet, comfortable, and polished travel experiences.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Buldhana MIDC',
    description: `Monthly fixed-route cab rental packages crafted to streamline employee transport and reduce administrative load. These plans provide consistent service quality, simplified billing, and seamless coordination with HR and corporate administrators.`
  },
  {
    name: 'Industrial Area Employee Transport Buldhana MIDC',
    description: `Optimized employee transport services designed for industrial workers, focusing on safety, punctuality, and compliance with industrial regulations. Our routing and scheduling ensure smooth travel between residential zones and industrial sites within Buldhana MIDC.`
  },
  {
    name: 'Corporate Client Cabs Buldhana MIDC',
    description: `Dedicated client transportation ensuring professional, comfortable, and punctual travel for visiting business guests. From airport pickups to corporate site visits, we help you create a strong positive impression with polished vehicles and trained drivers.`
  },
  {
    name: 'Business Meeting Cabs Buldhana MIDC',
    description: `Prompt and reliable cab services tailored for executives attending urgent or scheduled business meetings within Buldhana and surrounding regions. We offer easy booking, rapid dispatch, and professional service to keep your business moving efficiently.`
  },
  {
    name: 'Buldhana Industrial Area Cab Hire',
    description: `Flexible on-demand cab hire services for site visits, logistics, and corporate errands throughout Buldhana’s industrial corridors. Our experienced drivers provide efficient, hassle-free, and timely transportation within the industrial zones.`
  },
  {
    name: 'Corporate Shuttle Cabs Buldhana MIDC',
    description: `Group shuttle services using minibuses or large vans, ideal for bulk employee movements during shift changes or corporate events. This service enhances operational efficiency, reduces environmental impact, and ensures coordinated team travel.`
  }
],

tableData: [
  ['Buldhana MIDC Corporate Cab Rentals', 'Employee Transport Cab Buldhana MIDC'],
  ['Business Cab Services Buldhana MIDC', 'Corporate Staff Cabs Buldhana MIDC'],
  ['Reliable Corporate Cab Service Buldhana MIDC', 'AC Corporate Cabs Buldhana MIDC'],
  ['Staff Pickup and Drop Cab Buldhana MIDC', 'Affordable Business Cab Rentals Buldhana MIDC'],
  ['Executive Cab Services Buldhana MIDC', 'Monthly Corporate Cab Rentals Buldhana MIDC'],
  ['Industrial Area Employee Transport Buldhana MIDC', 'Corporate Client Cabs Buldhana MIDC'],
  ['Business Meeting Cabs Buldhana MIDC', 'Buldhana Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Buldhana MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Buldhana MIDC",
    "WhyChoosedescription": "eTravo delivers specialized cab services for businesses operating in Buldhana MIDC, focusing on timely, safe, and efficient employee transportation to support operational continuity and workforce satisfaction."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and multi-utility vehicles, ideal for a variety of corporate transportation needs such as daily commutes, executive movement, and client visits—all maintained for safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our trained drivers are well-acquainted with Buldhana MIDC’s roads and industrial zones, ensuring timely arrivals, efficient routes, and a professional travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We offer multiple booking options including pre-scheduled rides, on-demand cab services, and long-term contracts tailored to meet the varied shift schedules of industrial operations."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All eTravo cabs are GPS-enabled, allowing real-time tracking for enhanced passenger safety, driver accountability, and full visibility for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear and itemized invoices that include full trip details and cost breakdowns, making it easy for businesses to manage expenses and streamline reimbursements."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our vehicles undergo regular cleaning and maintenance, while drivers strictly follow hygiene and safety protocols to ensure a healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each business is assigned a dedicated account manager to oversee bookings, provide assistance, and ensure a seamless and reliable cab service experience in Buldhana MIDC."
  }
]









}

const faqData = [
  [
    {
      question: "Which areas do your Buldhana MIDC cab services cover?",
      answer: "Our services span across the entire Buldhana MIDC region and nearby industrial zones, ensuring smooth and reliable employee transportation."
    },
    {
      question: "Do you support cab scheduling for multiple shifts?",
      answer: "Yes, we provide flexible and recurring cab schedules tailored to your company’s shift patterns, including night and rotating shifts."
    },
    {
      question: "Is monthly corporate billing provided?",
      answer: "Yes, we offer monthly GST-compliant invoices along with detailed trip summaries to simplify your expense tracking and reporting."
    },
    {
      question: "Are the drivers trained for industrial transportation?",
      answer: "Absolutely. Our drivers are trained in safe driving, route efficiency, and corporate professionalism for industrial transport needs."
    },
    {
      question: "What safety protocols are followed during rides?",
      answer: "We prioritize safety with GPS tracking, sanitized vehicles, verified drivers, and responsive support for any on-road emergencies."
    },
    {
      question: "Do you offer dedicated support for corporate clients?",
      answer: "Yes, every corporate client is assigned an account manager with access to dedicated priority support for all service needs."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Nitin Kale",
    designation: "Factory Manager, Buldhana Auto Parts",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services have brought consistency and comfort to our employee transportation in Buldhana MIDC.”"
  },
  {
    name: "Ms. Rekha Desale",
    designation: "Admin Executive, Buldhana Industrial Plastics",
    rating: [1, 1, 1, 1, 1],
    text: "“Professional drivers, clean vehicles, and timely pickups—eTravo has truly improved our corporate transport operations.”"
  }
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Buldhana MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-buldhana-midc.jpg",
  "description": "Reliable corporate cab service in Buldhana MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-buldhana-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Buldhana MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Buldhana MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/91.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinbuldhana;